import { createAction, props } from '@ngrx/store';
import { ImportListItemResponse, MetaPagination } from '../../../api';

// Import history
export const loadImportHistory = createAction(
  '[Data Management] Load import history',
  props<{ page: number; size: number }>()
);
export const setImportHistory = createAction(
  '[Data Management] Set import history',
  props<{ payload: ImportListItemResponse[]; pagination: MetaPagination['page'] }>()
);
export const successImportHistory = createAction('[Data Management] Success import history');
export const errorImportHistory = createAction('[Data Management] Error import history');
